import React, { useState } from "react";
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";

const SignUp = (props) => {
    const host = 'https://cloudbackend-zb1i.onrender.com';
    const [credentials, setCredentials] = useState({ name: "", email: "", password: "" })
    const navigate = useNavigate();

    //this function is called user click on create account
    const handleSubmit = async (e) => {

        toast.info('Please Wait...', { autoClose: 2000, icon: "⏳" });

        console.log("Form is submited");
        //compare to password and conform password
        let password = document.getElementById("password");
        let cpassword = document.getElementById("cpassword");
        if (password.value !== cpassword.value) {

            toast.error("password and conform password must be same !")
        }

        //page will not reload
        e.preventDefault();
        // API call
        console.log("handlesubmit");
        const response = await fetch(`${host}/api/auth/createuser`, {

            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name: credentials.name, email: credentials.email, password: credentials.password })
        });
        const json = await response.json();
        // console.log(json);
        if (json.success) {
            //save the auth token in localstorage and redirect user
            // localStorage.setItem('token', json.authToken);
            //here we want to redirect user to the home so we write /home 

            toast.success('Account created... please login to continue.');
            setTimeout(() => {
                navigate("/login");
            }, 1000)
        }
        else {
            toast.warn(json.Error,{icon:"🙋"});
        }
    }
    const onChange = (event) => {

        setCredentials({ ...credentials, [event.target.name]: event.target.value });
    }
    document.title = "CloudNotes - SignUp";
    return (
        <><ToastContainer
            transition={Slide}
            position="top-center"
            autoClose={4000} />

            <div className="w-5/6 mx-auto bg-slate-200">
                <section className="min-h-screen bg-slate-200 h-auto">
                    <div className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full pt-20">
                        {/* <h2>New to Cloud Notes? sign up now and start your journey</h2> */}

                        {/* <h1 className="font-extrabold"> Add terms and condition </h1> */}
                        <div className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0 " >
                            <img
                                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg"
                                className="w-full"
                                alt="SingUp Label"
                            />
                        </div>
                        <div className="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2">
                            <div className="bg-slate-100  px-6 py-6 rounded shadow-md text-black w-full mb-7">
                                {/* form start here */}
                                <form onSubmit={handleSubmit}>
                                    <h1 className="mb-8 text-3xl text-center">Sign up</h1>
                                    <input
                                        type="text"
                                        className="block border border-grey-light w-full p-3 rounded mb-4"
                                        name="name"
                                        id="name" value={credentials.name} onChange={onChange}
                                        placeholder="Full Name" required />

                                    <input
                                        type="email"
                                        className="block border border-grey-light w-full p-3 rounded mb-4"
                                        name="email"
                                        id="email" value={credentials.email} onChange={onChange}
                                        placeholder="Email" required />

                                    <input
                                        type="password"
                                        className="block border border-grey-light w-full p-3 rounded mb-4"
                                        name="password"
                                        id="password" value={credentials.password} onChange={onChange}
                                        placeholder="Password" minLength={5} required />
                                    <input
                                        type="password"
                                        className="block border border-grey-light w-full p-3 rounded mb-4"
                                        name="cpassword" id="cpassword"
                                        placeholder="Confirm Password" minLength={5} required />

                                    <button type="submit" className="w-full text-center py-3 rounded bg-green text-white bg-green-500 focus:outline-none my-1"
                                    >Create Account</button>

                                    <div className="text-grey-dark mt-6">
                                        Already have an account?
                                        <Link to="/login" className="no-underline border-b border-blue px-1 text-gray-900">
                                            Log in
                                        </Link>.
                                    </div>
                                </form >
                            </div>



                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
export default SignUp;
